import { ReactNode } from 'react';
import { Stack, Typography } from '@rossum/ui/material';

type ContentTitleProps = {
  title: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  titleAction?: ReactNode;
};

export const ContentTitle = ({
  disabled,
  description,
  title,
  titleAction,
}: ContentTitleProps) => {
  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          variant="h5"
          color={disabled ? 'text.disabled' : 'text.primary'}
        >
          {title}
        </Typography>
        {titleAction}
      </Stack>
      {description ? (
        <Typography
          variant="body2"
          color={disabled ? 'text.disabled' : 'text.secondary'}
          component="span"
        >
          {description}
        </Typography>
      ) : null}
    </Stack>
  );
};
